export const projectTypes = ["premise", "apartment_building", "condominium_complex"];
